import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommercialFile} from "../models/commercialFile";
import {Qualification} from "../models/qualification";


const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/api/v1/qualification';

@Injectable()
export class QualificationService {

    constructor(private http: HttpClient) {
    }

    create(qualification: Qualification) {
        return this.http.post<Qualification>(apiUrl, qualification, httpOptions);
    }

}
